import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-config-page',
  templateUrl: './config-page.component.html',
  styleUrls: ['./config-page.component.scss']
})
export class ConfigPageComponent implements OnInit {

  newformmainconfig: FormGroup;
  constructor(private formBuilder: FormBuilder,
    private configService: ConfigService) {
    this.newformmainconfig = this.formBuilder.group({
      radius: [null, null]
    });
  }

  ngOnInit() {
    this.configService.getData().then(data => {
      this.newformmainconfig.controls['radius'].setValue(data.radiusKM);
    });
  }
  saveMainConfig() {
    const radius = this.newformmainconfig.controls['radius'].value;
    this.configService.update(radius).then(() => {
      alert('Done!');
    });
  }
}
